import { useQuery } from '@tanstack/react-query';
import ApiConstants from '../../constants/ApiConstants';
import xhr from '../../utils/api/xhr';

export type TimeRange = 'midnight' | 'morning' | 'afternoon' | 'evening';

export interface SlotAvailability {
  timestamp: string;
  available: boolean;
  count?: number;
}

interface SlotAvailabilitiesResponse {
  availabilities: SlotAvailability[];
}

async function fetchSlotAvailabilities(
  range: TimeRange,
  timeZone?: string
): Promise<SlotAvailabilitiesResponse> {
  let query = `range=${range}`;
  if (timeZone) {
    query += `&timeZone=${encodeURIComponent(timeZone)}`;
  }
  return xhr(`${ApiConstants.Base}/booking-calendar/load-availabilities?${query}`);
}

export const slotAvailabilitiesKeys = {
  all: ['slotAvailabilities'] as const,
  byRange: (range: TimeRange, timeZone?: string) =>
    ['slotAvailabilities', { range, timeZone }] as const,
};

export function useSlotAvailabilitiesQuery(range: TimeRange, timeZone?: string) {
  return useQuery({
    queryKey: slotAvailabilitiesKeys.byRange(range, timeZone),
    queryFn: () => fetchSlotAvailabilities(range, timeZone),
    enabled: !!range,
    // Slot availability data changes frequently, use shorter stale time
    staleTime: 1 * 60 * 1000, // 1 minute
  });
}
